module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/protocolo/protocolo.component.css
// module id = ./src/app/protocolo/protocolo.component.css
// module chunks = main